import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation, useHistory } from 'react-router-dom'

import SearchBar from 'components/SearchBar'
import Select from 'components/Select'
import UploadOrgAttendantsDialog from 'components/PosAccounts/UploadOrgAttendants/Dialog'

import { POS_ACCOUNTS_STATUSES, POS_ACCOUNTS_ROLES } from 'resources'
import { loadFilteredAndPaginatedAttendants } from 'store/Attendants/actions'
import { setQueryStringParameters } from 'store/AppState/actions'
import { posAccountsUtils } from 'components/PosAccounts/utils'
import useDebounce from 'hooks/useDebounce'
import { ReactComponent as IconUpload } from 'assets/icons/IconUpload.svg'

const ListFilters = ({ queryStringParameters }) => {
  const [isUploadDialogOpen, setIsUploadDialogOpen] = useState(false)
  const [searchQuery, setSearchQuery] = useState(
    queryStringParameters?.searchFor
  )

  const { pathname } = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()

  const onClickNew = () => {
    history.push({ state: { posAccountUuid: 'new' } })
  }

  const onUploadAttendantsCSVFileClick = () => {
    history.push({ state: { uploadAttendantsCSVFile: true } })
    setIsUploadDialogOpen(true)
  }

  const handleChangeRolesSelect = (value) => {
    const employeeRole =
      posAccountsUtils.transformEmployeeRoleToSend(value)

    const updatedParams = {
      ...queryStringParameters,
      page: 1,
      employeeRole,
    }

    handleLoadPosAccounts(updatedParams)
  }

  const handleChangeStatusSelect = (value) => {
    const active = posAccountsUtils.transfromActiveValueToSend(value)

    const updatedParams = {
      ...queryStringParameters,
      page: 1,
      active,
    }

    handleLoadPosAccounts(updatedParams)
  }

  const debouncedFetchItemsWithSearchParams = useDebounce(() => {
    const updatedParams = {
      ...queryStringParameters,
      page: 1,
      searchFor: searchQuery,
    }

    handleLoadPosAccounts(updatedParams)
  }, 500)

  const handleSearch = (value) => {
    setSearchQuery(value)
    debouncedFetchItemsWithSearchParams()
  }

  const handleLoadPosAccounts = (params) => {
    dispatch(setQueryStringParameters(params, pathname))
    dispatch(loadFilteredAndPaginatedAttendants(params))
  }

  return (
    <>
      <div className="pos-accounts-filters">
        <UploadOrgAttendantsDialog
          isOpen={isUploadDialogOpen}
          setIsUploadDialogOpen={setIsUploadDialogOpen}
        />
        <Select
          handleChange={handleChangeRolesSelect}
          options={POS_ACCOUNTS_ROLES}
          label="All Staff"
          nameClass="-shorter  margin-right-xs"
        />
        <Select
          handleChange={handleChangeStatusSelect}
          options={POS_ACCOUNTS_STATUSES}
          label="All Statuses"
          nameClass="-shorter"
        />
        <SearchBar
          searchQuery={searchQuery}
          handleSearch={handleSearch}
        />
        <button
          type="button"
          className="btn-reset upload-icon"
          onClick={onUploadAttendantsCSVFileClick}
        >
          <IconUpload />
        </button>
        <button
          className="btn new-item"
          type="button"
          onClick={onClickNew}
        >
          <span className="new-item -cross"></span>
          <span className="new-item -cross"></span>
        </button>
      </div>
    </>
  )
}

export default ListFilters
